import React from 'react'

type Props = {}

const ListOfApplicants = (props: Props) => {


    return (
        <div>ListOfApplicants</div>
    )
}

export default ListOfApplicants